import React, { ChangeEvent, useState } from 'react';
import TableFiltersWrapper from 'ui/TableInputs/TableFiltersWrapper/TableFiltersWrapper';
import TableInput from 'ui/TableInputs/TableInput/TableInput';

interface IRecallBulkPepaidFilter {
  onSubmitFilters: (query: ISearchParams) => void;
}

export interface ISearchParams {
  bulkId?: string;
  scheduleId?: string;
}

const RecallBulkPepaidFilter = ({ onSubmitFilters }: IRecallBulkPepaidFilter) => {
  const [state, setState] = useState<ISearchParams>({
    bulkId: '',
    scheduleId: '',
  });
  const updateState = (update: Partial<ISearchParams>) => setState((current) => ({ ...current, ...update }));

  const handleFilterChange = (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    const { name, value } = e.target;
    return updateState({ [name as keyof ISearchParams]: value as string });
  };

  const handleClearInput = (name: string) => () => {
    updateState({ [name as keyof ISearchParams]: '' });
  };

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmitFilters(state);
  };

  const styles = {
    marginTop: '20px',
  };

  return (
    <>
      <div style={styles}>
        <form onSubmit={handleOnSubmit}>
          <TableFiltersWrapper>
            <TableInput
              name="bulkId"
              label="Bulk ID"
              onClickClear={handleClearInput('bulkId')}
              value={state.bulkId}
              fullWidth
              onChange={handleFilterChange}
              autoComplete="off"
              showIcon
            />
            <TableInput
              name="scheduleId"
              label="Schedule ID"
              onClickClear={handleClearInput('scheduleId')}
              value={state.scheduleId}
              fullWidth
              onChange={handleFilterChange}
              autoComplete="off"
              showIcon
            />
          </TableFiltersWrapper>
        </form>
      </div>
    </>
  );
};

export default RecallBulkPepaidFilter;
